// Shared, user-facing copy for WebRTC media/connection errors so every video
// surface reports the same thing the same way.
//
// Known getUserMedia DOMException names get a specific, actionable message.
// Anything else falls through to the error's name + message so it is never
// silently mislabeled (e.g. Chrome's RTCPeerConnection-cap error surfaces here).
export function describeWebrtcError(err) {
  if (!err) {
    return 'An unknown video error occurred.'
  }
  switch (err.name) {
    case 'NotAllowedError':
      return 'Camera/microphone access was denied. Please check your browser permissions.'
    case 'NotFoundError':
      return 'No camera/microphone found. Please connect a device and try again.'
    case 'NotReadableError':
      return 'Camera/microphone is already in use by another application. Please close other apps and try again.'
    case 'OverconstrainedError':
      return 'No camera/microphone matches the required settings. Please try a different device.'
    case 'SecurityError':
      return 'Camera/microphone access is blocked by your browser security settings.'
    case 'AbortError':
      return 'Media request was cancelled.'
    default:
      return `Unexpected video error (${err.name || err.constructor?.name || 'Error'}): ${err.message || 'no details available'}.`
  }
}
